import React from 'react'

import { faClock, faRocketLaunch } from '@fortawesome/pro-solid-svg-icons'
import { faClock as faClockLight, faRocketLaunch as faRocketLaunchLight } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ONE_TIME, AUTOMATED } from '../outreach-message-types'

export const DISPLAY_ORDER = [ONE_TIME, AUTOMATED]

export const TABS = {
  [ONE_TIME]: {
    text: 'One-Time',
    value: ONE_TIME,
    getUrl: (url) => `${url}/one-time`,
    icons: {
      active: faClock,
      inactive: faClockLight,
    },
  },

  [AUTOMATED]: {
    text: 'Automated',
    value: AUTOMATED,
    getUrl: (url) => `${url}/automated`,
    icons: {
      active: faRocketLaunch,
      inactive: faRocketLaunchLight,
    },
  },
}

export const getIcon = (icons, active) => {
  const iconDoesNotExist = !icons.active || !icons.inactive
  const icon = active ? icons.active : icons.inactive

  if (iconDoesNotExist) return null
  return <FontAwesomeIcon icon={icon} />
}
